import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataListModel} from '../models/data-list-model';
import {LogEntity} from '../dto/log-entity';
import {CityInfo} from '../dto/GeoIp/city-info';

@Injectable({
  providedIn: 'root'
})
export class GeoIpService {

  readonly apiPath = 'geoip/';
  constructor(
    private http: HttpClient,
  ) { }

  getCityByIp(
    ipAddress: string,
  ): Observable<CityInfo> {
    return this.http.get(this.apiPath + ipAddress) as Observable<CityInfo>;
  }
}
